import ClientFactory, { ErrorHandler } from '@xfinity/maw-fetch';

const onError = ErrorHandler();

const client = ClientFactory({
  logger: { log: () => {} },
  onError,
});

export default client;
